import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import MemberCard from './pages/MemberCard';
import Benefits from './pages/Benefits';
import Admin from './pages/Admin';
import Home from './pages/Home';
import Login from './pages/Login';
import OrderForm from './pages/OrderForm';
import ReorderForm from './pages/ReorderForm';
import IntroForm from './pages/IntroForm';
import PlayerPage from './pages/PlayerPage';
import ClipOrderForm from './pages/ClipOrderForm';
import ClipOrdersApp from './pages/ClipOrdersApp';
import './App.css';

// ── Auth helpers ─────────────────────────────────────────────
const TOKEN_KEY = 'ustar_admin_token';
const isLoggedIn = () => !!localStorage.getItem(TOKEN_KEY);
export const logout = () => { localStorage.removeItem(TOKEN_KEY); window.location.href = '/login'; };

// ── Protected wrapper ────────────────────────────────────────
function ProtectedAdmin() {
  const [authed, setAuthed] = useState(isLoggedIn());
  const navigate = useNavigate();

  // If visiting admin.ustarclub.co.il root, go straight to /admin
  useEffect(() => {
    const host = window.location.hostname;
    if (host.startsWith('admin.') && window.location.pathname === '/') {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  if (!authed) {
    return <Login onLogin={() => setAuthed(true)} />;
  }
  return <Admin onLogout={() => { logout(); setAuthed(false); }} />;
}

// ── Root redirect for admin subdomain ───────────────────────
function RootPage() {
  const host = window.location.hostname;
  if (host.startsWith('admin.')) {
    return <Navigate to="/admin" replace />;
  }
  return <Home />;
}

export default function App() {
  return (
    <div className="app" dir="rtl">
      <Routes>
        <Route path="/"           element={<RootPage />} />
        <Route path="/card/:id"   element={<MemberCard />} />
        <Route path="/benefits"   element={<Benefits />} />
        <Route path="/login"      element={<LoginRoute />} />
        <Route path="/admin"      element={<ProtectedAdmin />} />
        <Route path="/admin/*"    element={<ProtectedAdmin />} />
        <Route path="/order"           element={<OrderForm />} />
        <Route path="/order/:templateId" element={<OrderForm />} />
        <Route path="/reorder/:id" element={<ReorderForm />} />
        <Route path="/intro"      element={<IntroForm />} />
        <Route path="/join"       element={<Home scrollToForm />} />
        <Route path="/pro/:slug"  element={<PlayerPage />} />
        {/* אפליקציית לקוחות יוסטאר — קליפ אישי */}
        <Route path="/clip-order/:formId" element={<ClipOrderForm />} />
        <Route path="/clip-orders"        element={<ProtectedClipOrders />} />
      </Routes>
    </div>
  );
}

// ── אפליקציית הקליפים האישיים — אותו טוקן ניהול, מסך נפרד ──
function ProtectedClipOrders() {
  const [authed, setAuthed] = useState(isLoggedIn());
  if (!authed) return <Login onLogin={() => setAuthed(true)} />;
  return <ClipOrdersApp onLogout={() => { logout(); setAuthed(false); }} />;
}

// Redirect to /admin if already logged in
function LoginRoute() {
  if (isLoggedIn()) return <Navigate to="/admin" replace />;
  return <Login onLogin={() => { window.location.href = '/admin'; }} />;
}
